import { array, intersect, partial, string, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as RecipeGroupId } from '../../../../../whole-house/canvas/recipe-group/Id';

const BulkUpdateRecipeGroup = intersect(
	struct({
		id: RecipeGroupId,
		name: string,
		recipeIds: array(iotsUtils.withPrefix('canvas-recipe')),
	})
)(
	partial({
		parentId: RecipeGroupId,
	})
);

export const Request = struct({
	recipeGroups: array(BulkUpdateRecipeGroup),
});
